import React from 'react';

const Footer = () => {
  return (
    <footer className="font-sora bg-black text-white py-6 px-6 md:px-16 flex flex-col md:flex-row justify-between items-center gap-4">
       <div className="font-bold text-xl flex items-center gap-2">

       </div>
       
       <div className="text-sm text-gray-400">
         © 2025-2026 Ishika Ishani
       </div>
       
       <div className="text-sm text-gray-400">

       </div>
    </footer>
  );
};

export default Footer;